/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Missiontitle1Inputs */

const id_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misi Kami`)
};

const ms_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misi Kami`)
};

const da_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vores Mission`)
};

const de_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Mission`)
};

const en_us2_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Mission`)
};

const es_es2_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra misión`)
};

const es_mx2_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra misión`)
};

const fil_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aming Misyon`)
};

const fr_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre mission`)
};

const it_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La nostra missione`)
};

const hu_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küldetésünk`)
};

const nl_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze missie`)
};

const no_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vår misjon`)
};

const pl_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasza misja`)
};

const pt_br2_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nossa Missão`)
};

const pt_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A nossa missão`)
};

const ro_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misiunea noastră`)
};

const fi_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävämme`)
};

const sv_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vårt uppdrag`)
};

const vi_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sứ mệnh của chúng tôi`)
};

const tr_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misyonumuz`)
};

const cs_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naše mise`)
};

const bg_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нашата мисия`)
};

const ru_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наша миссия`)
};

const uk_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наша місія`)
};

const ar_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهمتنا`)
};

const hi_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारा मिशन`)
};

const th_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พันธกิจของเรา`)
};

const ja_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちの使命`)
};

const zh_cn2_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的使命`)
};

const zh_hant1_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們的使命`)
};

const ko_privacy_missiontitle1 = /** @type {(inputs: Privacy_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우리의 사명`)
};

/**
* | output |
* | --- |
* | "Our Mission" |
*
* @param {Privacy_Missiontitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_missiontitle1 = /** @type {((inputs?: Privacy_Missiontitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Missiontitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_missiontitle1(inputs)
	if (locale === "ms") return ms_privacy_missiontitle1(inputs)
	if (locale === "da") return da_privacy_missiontitle1(inputs)
	if (locale === "de") return de_privacy_missiontitle1(inputs)
	if (locale === "en-US") return en_us2_privacy_missiontitle1(inputs)
	if (locale === "es-ES") return es_es2_privacy_missiontitle1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_missiontitle1(inputs)
	if (locale === "fil") return fil_privacy_missiontitle1(inputs)
	if (locale === "fr") return fr_privacy_missiontitle1(inputs)
	if (locale === "it") return it_privacy_missiontitle1(inputs)
	if (locale === "hu") return hu_privacy_missiontitle1(inputs)
	if (locale === "nl") return nl_privacy_missiontitle1(inputs)
	if (locale === "no") return no_privacy_missiontitle1(inputs)
	if (locale === "pl") return pl_privacy_missiontitle1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_missiontitle1(inputs)
	if (locale === "pt") return pt_privacy_missiontitle1(inputs)
	if (locale === "ro") return ro_privacy_missiontitle1(inputs)
	if (locale === "fi") return fi_privacy_missiontitle1(inputs)
	if (locale === "sv") return sv_privacy_missiontitle1(inputs)
	if (locale === "vi") return vi_privacy_missiontitle1(inputs)
	if (locale === "tr") return tr_privacy_missiontitle1(inputs)
	if (locale === "cs") return cs_privacy_missiontitle1(inputs)
	if (locale === "bg") return bg_privacy_missiontitle1(inputs)
	if (locale === "ru") return ru_privacy_missiontitle1(inputs)
	if (locale === "uk") return uk_privacy_missiontitle1(inputs)
	if (locale === "ar") return ar_privacy_missiontitle1(inputs)
	if (locale === "hi") return hi_privacy_missiontitle1(inputs)
	if (locale === "th") return th_privacy_missiontitle1(inputs)
	if (locale === "ja") return ja_privacy_missiontitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_missiontitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_missiontitle1(inputs)
	return ko_privacy_missiontitle1(inputs)
});
export { privacy_missiontitle1 as "privacy.missionTitle" }